import { Component } from "react";

import LegacyDispatcher from "~/lib/legacyDispatcher";
import BuildRow from "~/components/build/BuildRow";
import { noop } from "lodash";

import BranchStore, { Branch, Project } from "~/stores/BranchStore";
import Icon from "~/components/shared/Icon";

type Props = {
  branch: Branch;
  project: Project;
  store: BranchStore;
};

// eslint-disable-next-line react/require-optimization
export default class BranchListBranch extends Component<Props> {
  render() {
    const starredClassName = this.props.branch.starred
      ? "better-branch-starred"
      : "better-branch-not-starred";

    return (
      <div
        className={`panel panel-default better-branch-panel mb-4 ${starredClassName} depth-150 rounded-1.5 mb-6 w-full border-none antialiased`}
        data-branch={this.props.branch.name}
      >
        <div className="panel-heading rounded-top-1.5 charcoal-700 flex items-center bg-slate-100">
          <div className="min-w-0 flex-auto">
            <h2 className="m-0 flex items-center text-sm font-normal">
              <Icon
                icon="custom/outline/14x/branch"
                className="mr-0.5"
                style={{ height: 14, width: 14 }}
              />
              <a
                className="no-highlight-link better-branch-panel-name hover-color-inherit"
                href={this.props.branch.path}
              >
                {this.props.branch.name}
              </a>
            </h2>
          </div>
          <div className="flex items-center">
            {this.renderStarButton()}
            {this.renderRemoveButton()}
          </div>
        </div>
        {this.props.branch.builds &&
          this.props.branch.builds.map((build) => (
            <BuildRow
              key={build.id}
              // @ts-expect-error - TS2740 - Type 'Build' is missing the following properties from type '{ id: string; authorName: string; blockedState: string | null; branchName: string; branchPath: string; canceledAt: string | null; commitId: string; commitShortLength: number; commitUrl: string; ... 10 more ...; project: { ...; }; }': blockedState, canceledAt, commitUrl, finishedAt, and 2 more.
              build={build}
              setBuildData={noop}
              reloadBuild={noop}
              showStepsToggle={false}
            />
          ))}
      </div>
    );
  }

  renderStarButton() {
    if (this.props.project.permissions.favoriteProject.allowed) {
      if (this.props.branch.starred) {
        return (
          <a
            href="#"
            onClick={this.handleUnstarClick}
            className="better-branch-star-button h-4 w-4"
            aria-label={`Unfavorite ${this.props.branch.name} branch`}
            title={`Unfavorite ${this.props.branch.name} branch`}
          >
            <Icon icon="heroicons/solid/star" className="block h-4 w-4" />
          </a>
        );
      }
      return (
        <a
          href="#"
          onClick={this.handleStarClick}
          className="better-branch-star-button h-4 w-4"
          aria-label={`Favorite ${this.props.branch.name} branch`}
          title={`Favorite ${this.props.branch.name} branch`}
        >
          <Icon icon="heroicons/outline/star" className="block h-4 w-4" />
        </a>
      );
    }

    return null;
  }

  renderRemoveButton() {
    if (this.props.project.permissions.edit.allowed) {
      return (
        <a
          href="#"
          onClick={this.handleRemoveClick}
          className="better-branch-remove-button hover-color-inherit h-4 w-4"
          aria-label={`Remove ${this.props.branch.name} branch`}
          title={`Remove ${this.props.branch.name} branch`}
        >
          <Icon icon="heroicons/outline/no-symbol" className="block h-4 w-4" />
        </a>
      );
    }
  }

  handleStarClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // @ts-expect-error - TS2554 - Expected 6 arguments, but got 2.
    LegacyDispatcher.emit("project_branch:star", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleUnstarClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // @ts-expect-error - TS2554 - Expected 6 arguments, but got 2.
    LegacyDispatcher.emit("project_branch:unstar", {
      project: this.props.project,
      branch: this.props.branch.name,
    });
  };

  handleRemoveClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (confirm("Remove this branch until new builds are pushed?")) {
      this.props.store.removeBranch(this.props.branch.name);
    }
  };
}
